import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  AddTeamLayer  from '../components/teams/AddTeamLayer'

export const AddTeamPage = () => {
  return (
    <MasterLayout>
        <AddTeamLayer/>
    </MasterLayout>
  )
}
